import { render, staticRenderFns } from "./DispensationActivity.vue?vue&type=template&id=f82af29c&scoped=true&"
import script from "./DispensationActivity.vue?vue&type=script&lang=js&"
export * from "./DispensationActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82af29c",
  null
  
)

export default component.exports